import { useContext } from 'react';

import { useSelector } from '../../../../selectors/useSelector';

import { ModularListingContext } from '../../../../containers/CreateListingPage/context';
import { DISPLAY_SERVER_ERROR_AT } from '../../../../constants/WizardConstants';
import ListingTour from '../../../../components/postingPath/ListingTour';
import WizardAlert from '../../../../components/WizardAlert';

import { StyledDiv } from './StyledComponents';

type Props = {
  isRelistingFieldset?: boolean;
};

const ListingToursFormField = ({ isRelistingFieldset = false }: Props) => {
  const {
    modularListingState: { serverErrorObj },
  } = useContext(ModularListingContext);

  const {
    user: {
      features: { canUpdateListing },
    },
    properties: {
      currentProperty: {
        isArchived,
        isMultifamily,
        isFeed,
        restrictions: { isUpdateListingRestricted },
        selfServeOnboardingStatus: { isSelfServeOnboardingInProgress, isUpdateRestricted: isSSOBUpdateRestricted },
      },
    },
  } = useSelector((state) => state);

  const isDisabled =
    !canUpdateListing ||
    isArchived ||
    isUpdateListingRestricted ||
    (isSelfServeOnboardingInProgress && isSSOBUpdateRestricted);
  const is3dTourDisabled = isFeed ? isArchived || isUpdateListingRestricted : isDisabled;

  return (
    <StyledDiv data-testid="ListingToursFormField">
      <WizardAlert serverErrorObj={serverErrorObj} displayAt={DISPLAY_SERVER_ERROR_AT.FIELD} />
      <ListingTour
        tourType={isMultifamily ? 'amenity' : 'singleFamily'}
        isDisabled={is3dTourDisabled}
        updateStatusMessage={() => {}}
        isRelistingFieldset={isRelistingFieldset}
      />
    </StyledDiv>
  );
};

export default ListingToursFormField;
